import { render, staticRenderFns } from "./AddStop.vue?vue&type=template&id=04942724&scoped=true&"
import script from "./AddStop.vue?vue&type=script&lang=js&"
export * from "./AddStop.vue?vue&type=script&lang=js&"
import style0 from "./AddStop.vue?vue&type=style&index=0&id=04942724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04942724",
  null
  
)

component.options.__file = "AddStop.vue"
export default component.exports